<template>
  <div class="tw-flex tw-grid tw-grid-cols-4 tw-gap-6 tw-mb-8">
    <task-type-item title="All Tasks" icon="bx bx-list-check" value="all" :current="value" v-on:click.native="setType('all')"/>
    <task-type-item title="To Do" icon="bx bx-plus" value="todo" :current="value" v-on:click.native="setType('todo')"/>
    <task-type-item title="In Progress" icon="bx bx-hourglass" value="inprogress" :current="value" v-on:click.native="setType('inprogress')"/>
    <task-type-item title="Done" icon="bx bx-check" value="done" :current="value" v-on:click.native="setType('done')"/>
  </div>
</template>

<script>
  import TaskTypeItem from "./TaskTypeItem"

  export default {
    components: {
      TaskTypeItem
    },
    name: "task-type",
    props: {
      value: {
        type: String,
        default: null
      }
    },
    data() {
      return {
        type: null
      };
    },
    methods: {
      setType: function (type) {
        this.type = type;
        this.$emit("input", this.type);
      }
    },
    watch: {
      value: {
        immediate: true,
        handler() {
          this.type = this.value;
        }
      }
    }
  };
</script>
<style>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
  }
</style>
